export default "<div class=\"custom-content\">\r\n    {{html content}}\r\n</div>";